module.exports = __webpack_public_path__ + "img/pypi-defender.2146b756.svg";